export const removeEmailFromDisplayName = (displayName) => {
    const match = findEmailMatch(displayName);
    if (match) {
        return displayName.substring(0, match.index);
    }
    return displayName;
}

export const extractEmailFromDisplayName = (displayName) =>  {
    const match = findEmailMatch(displayName);
    if (match) {
        return displayName.substring(match.index + '<'.length, displayName.length - '>'.length);
    }
    return '';
}

const findEmailMatch = (displayName) => {
    const regexPattern = /<\S+@\S+\.\S+>/;
    return regexPattern.exec(displayName);
}


// WEBPACK FOOTER //
// ./src/utils/emailInDisplayName.js